import React from "react";
import { Table } from "react-bootstrap";

import { StripedRowsWithColsItemsType } from "./stripedRowsWithCols";

import styles from "./layout.module.scss";

type ClassicTableProps = {
	headerItems?: StripedRowsWithColsItemsType;
	bodyItems: StripedRowsWithColsItemsType;
	customHeader?: React.ReactNode | JSX.Element;
	customFooter?: React.ReactNode | JSX.Element;
	bordered?: "horizontal";
	transparent?: boolean;
	striped?: boolean;
	borderless?: boolean;
};

export const ClassicTable = ({
	headerItems,
	bodyItems,
	customHeader,
	customFooter,
	striped = false,
	borderless = true,
	bordered,
}: ClassicTableProps) => {
	const borderedClass = bordered === "horizontal" ? styles.tableBordered : "";

	return (
		<Table
			striped={striped}
			borderless={borderless}
			bordered={false}
			className={`${styles.classicTable} ${borderedClass}`}
		>
			<thead>
				{customHeader}
				{headerItems &&
					headerItems?.map?.(({ row }, index) => (
						<tr key={`row${index}`}>
							{row?.map((col, i) => (
								<th
									key={`col${index}${i}`}
									className={col.className}
								>
									{col.label}
								</th>
							))}
						</tr>
					))}
			</thead>

			<tbody>
				{bodyItems?.map?.(({ row }, index) => (
					<tr key={`row${index}`}>
						{row?.map((col, i) => (
							<td
								key={`col${index}${i}`}
								className={col.className}
							>
								{col.value}
							</td>
						))}
					</tr>
				))}
			</tbody>
			<tfoot>{customFooter}</tfoot>
		</Table>
	);
};
